import React from 'react';

import { IconClose } from '../../../../icons';
import { iTag } from '../../../../core/models/Tag';
import Button from '../../../../components/Button/Button';

interface TagsBarProps {
    selectedTags: iTag[];
    handleRemoveTag: (id: number) => void;
}

const TagsBar: React.FC<TagsBarProps> = ({ selectedTags, handleRemoveTag }) => {
    if (selectedTags.length === 0) {
        return null;
    }

    return (
        <div className="NewsBrowseSection__tags-section">
            <div className="NewsBrowseSection__tags-container">
                <div>
                    {selectedTags.length > 0 && (
                        <div className="NewsBrowseSection__tags">
                            <span className="NewsBrowseSection__tags-label">Tags:</span>
                            {selectedTags.map((tag) => (
                                <Button
                                    key={tag.id}
                                    onClick={() => handleRemoveTag(tag.id)}
                                    className="NewsBrowseSection__tag"
                                    unstyled
                                >
                                    {tag.title}
                                    <IconClose className="NewsBrowseSection__tag-icon" />
                                </Button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TagsBar;
